// eslint-disable-next-line no-unused-vars
import React, { memo, useState, useEffect } from 'react';

import useRouter from 'Hooks/useRouter';
import useFetch from 'Hooks/useFetch';
import useAsyncError from 'Hooks/useAsyncError';
import PromotionBannerComponent from 'Components/Products/PromotionBanner';
import { API_PRODUCTS_PROMOTIONS } from 'Constants';

const PromotionBanner = memo(() => {
  const { query } = useRouter();
  const fetcher = useFetch();
  const throwError = useAsyncError();
  const [content, setContent] = useState(null);

  const promotionCode = query?.promotion;

  useEffect(() => {
    if (!promotionCode) {
      setContent(null);
      return;
    }

    const fetchPromotionBanner = async () => {
      try {
        const response = await fetcher(`${API_PRODUCTS_PROMOTIONS}/${encodeURIComponent(promotionCode)}`);
        setContent(response);
      } catch (err) {
        throwError(err);
        setContent(null);
      }
    };

    fetchPromotionBanner();
  }, [promotionCode]);

  if (!content?.imageUrl) {
    return null;
  }

  return (
    <PromotionBannerComponent content={ content } />
  );
});

PromotionBanner.displayName = 'PromotionBannerContainer';

export default PromotionBanner;
